module.exports = __webpack_public_path__ + "static/4-f180bc02af253a7b66d29a18969e5c78.jpg";